(function () {
  'use strict';
  if (window.__qiServiceBuyLabelLoaded) return;
  window.__qiServiceBuyLabelLoaded = true;
  function init(scope) {
    if (scope.dataset.qiLabelInitialised) return;
    const button = scope.querySelector('.product-form__submit');
    if (!button) return;
    scope.dataset.qiLabelInitialised = 'true';
    function update() {
      let soldOut = false;
      try {
        const product = JSON.parse(scope.querySelector('[id^="qi-product-json-"]')?.textContent || '{}');
        const variantId = scope.querySelector('form [name="id"]')?.value;
        const variant = product.variants?.find(item => String(item.id) === variantId);
        soldOut = product.available === false || !variantId || variant?.available === false;
      } catch (_) {}
      const ended = scope.dataset.qiEnded === 'true' || scope.dataset.qiChristmasEnded === 'true';
      const text = scope.dataset.qiChristmasEnded === 'true' ? 'Qi Christmas Has Now Ended' : soldOut ? window.variantStrings?.soldOut || 'Sold out' : scope.dataset.buylabel;
      const span = button.querySelector('span');
      if (span && text && span.textContent.trim() !== text) span.textContent = text;
      if (text) button.setAttribute('aria-label', text);
      button.classList.add('atc-ready');
      if (ended || soldOut) { button.disabled = true; button.setAttribute('aria-disabled', 'true'); }
      else if (!button.classList.contains('loading')) { button.disabled = false; button.removeAttribute('aria-disabled'); }
    }
    scope.addEventListener('change', update);
    const observer = new MutationObserver(update);
    observer.observe(button, { childList: true, subtree: true, characterData: true });
    const productJson = scope.querySelector('[id^="qi-product-json-"]');
    if (productJson) observer.observe(productJson, { childList: true, subtree: true, characterData: true });
    update();
  }
  function initAll(container) { container.querySelectorAll('[id^="ProductInfo-"][data-buylabel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
